import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<DeleteDynamicLinkResponse, string>({
    query: (id) => ({
      url: `/v5/link/${id}`,
      method: 'DELETE',
    }),
  });

export interface DeleteDynamicLinkResponse {
  message: string;
  code: number;
}
